import type { Page } from '../../types';

const briberyInvestigations: Page[] = [
  {
    pageType: 'question',
    title: 'Bribery Investigations',
    name: 'bribery-investigations-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of bribery investigations to declare?',
        name: 'bribery_investigations_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Bribery Investigations',
    name: 'bribery-investigations',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'bribery_investigations_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'How many investigations were brought forward?',
        name: 'bribery_investigations_forward',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many investigations were opened?',
        name: 'bribery_investigations_opened',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many investigations were closed?',
        name: 'bribery_investigations_closed',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'bribery_investigations_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default briberyInvestigations;




